// src/components/shared/ServiceCard/ServiceCardHeader.tsx

import React from 'react';
import { AnyService } from '../../../types/service.type';
import ServiceTypeIcon from '../ServiceTypeIcon/ServiceTypeIcon';
import ServiceStatusBadge from '../ServicesStatusBadge/ServicesStatusBadge';

interface ServiceCardHeaderProps {
  service: AnyService;
  variant: 'compact' | 'default' | 'detailed';
}

const ServiceCardHeader: React.FC<ServiceCardHeaderProps> = ({ service, variant }) => {
  const showTypeIcon = variant !== 'compact';

  return (
    <div className="flex items-start justify-between mb-3">
      <div className="flex items-start gap-3 flex-1 min-w-0">
        {showTypeIcon && (
          <ServiceTypeIcon 
            type={service.type} 
            size={variant === 'detailed' ? 'md' : 'sm'} 
          />
        )}
        
        <div className="flex-1 min-w-0">
          <h3 className={`
            font-semibold text-gray-900 dark:text-white truncate
            ${variant === 'compact' ? 'text-sm' : variant === 'detailed' ? 'text-lg' : 'text-base'}
          `}>
            {service.name}
          </h3>
          
          {service.primaryUrl && (
            <p className={`
              text-gray-500 dark:text-gray-400 truncate font-mono
              ${variant === 'compact' ? 'text-xs' : 'text-sm'}
            `}>
              {service.primaryUrl.replace(/^https?:\/\//, '')}
            </p>
          )}
        </div>
      </div>

      <ServiceStatusBadge 
        status={service.status}
        size={variant === 'compact' ? 'sm' : 'md'}
        showLabel={variant !== 'compact'}
      />
    </div>
  );
};

export default ServiceCardHeader;